import { Config } from '@/state/session';
import NavigationDrawerItem from '@/components/Header/NavigationDrawer/NavigationDrawerItem';
import NavigationDrawerItemGroup from '@/components/Header/NavigationDrawer/NavigationDrawerItemGroup';

export const settingsPermissions: Record<string, keyof Config['auth']> = {
  bufferTimes: 'allowViewBufferTime',
  clientMappings: 'allowViewProviderLocationMapping',
  variableTimes: 'allowViewVariableTime',
  combineRules: 'allowViewCombineRule',
  trainingCategories: 'allowViewTrainingSettings',
  trainingQuestions: 'allowViewTrainingSettings',
};

const SettingsGroup = (): JSX.Element => (
  <>
    <NavigationDrawerItemGroup title="Company Management" permissions={Object.values(settingsPermissions)}>
      <NavigationDrawerItem name="Buffer Times" to="/settings/buffer-times" restricted permissions={[settingsPermissions.bufferTimes]} />
      <NavigationDrawerItem
        name="Variable Times"
        to="/settings/variable-times"
        restricted
        permissions={[settingsPermissions.variableTimes]}
      />
      <NavigationDrawerItem name="Combine Rules" to="/settings/combine-rules" restricted permissions={[settingsPermissions.combineRules]} />
      <NavigationDrawerItem
        name="Client Mappings"
        to="/settings/client-mappings"
        restricted
        permissions={[settingsPermissions.clientMappings]}
      />
    </NavigationDrawerItemGroup>
    <NavigationDrawerItemGroup title="Training Checklist">
      <NavigationDrawerItem
        name="Categories"
        to="/settings/training/categories"
        restricted
        permissions={[settingsPermissions.trainingCategories]}
      />
      <NavigationDrawerItem
        name="Questions"
        to="/settings/training/questions"
        restricted
        permissions={[settingsPermissions.trainingQuestions]}
      />
    </NavigationDrawerItemGroup>
  </>
);

export default SettingsGroup;
